// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2af5e0ad","396":"3ac602e9","432":"2a08b5c9","637":"acb13b3f","642":"0f9dd39e","793":"9e8eba4e"}[chunkId] + ".chunk.js";
};